export const fetchUsers = ({ clientID }): Function => (
  state,
  actions,
): Promise<void> => {
  const { api } = state;

  if (state.users.length) {
    return;
  }

  const headers = new Headers({ authorization: state.authorization });

  fetch(`${api}/v1/places/${clientID}/users`, { headers })
    .then(response => response.json())
    .then(users => actions.setUsers({ users }));

  return {
    ...state,
    loadingUsers: true,
  };
};
